<template>
  <div class="ecm-address">
    <div class="ecm-address__nav">
      <div class="ecm-address__add-address">
        <button @click="handleOpenAddAddress" class="ecm-address__add-address__btn btn--add-address">
          Add New Address
        </button>
      </div>
    </div>
    <div class="ecm-address__body">
      <CardAddress
        v-for="address in addresses" :key="address.id"
        :address="address"
        @handleMainAddress="handleMainAddress"
        @handleUpdateAddress="handleUpdateAddress"
        @handleDeleteAddress="handleOpenDeleteAddress"
      />
      <DeleteItem
        :message="'Are you sure to delete your address'"
        ref="deleteRef"
        @handleDeleteItem="handleDeleteAddress"
      />
      <AddAddress
        ref="addRef"
        :title="titlePropsAddress"
        @handleFetchAddresses="handleFetchAddresses"
      />
    </div>
  </div>
</template>

<script>
import Input from '@/components/inputs/Input.vue'
import CardAddress from '@/components/settings/address/Card.vue';
import DeleteItem from '@/components/modals/DeleteItem.vue'
import AddAddress from '@/components/modals/AddAddress.vue'
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Addresses',
  components: {
    Input,
    CardAddress,
    DeleteItem,
    AddAddress
  },
  data () {
    return {
      searchForm: {
        search: ''
      },
      addressId: null,
      titlePropsAddress: ''
    }
  },
  computed: {
    ...mapState({
      addresses: state => state.address.addresses
    })
  },
  methods: {
    ...mapActions({
      updateIsMainAddress: 'address/updateIsMainAddress',
      fetchAddresses: 'address/fetchAddresses',
      deleteAddress: 'address/deleteAddress'
    }),
    async handleMainAddress ({ addressId }) {
      try {
        const data = await this.updateIsMainAddress({ addressId })
        if (data.msg === 'successfully update address') {
         this.handleFetchAddresses()
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleUpdateAddress ({ receiver, phone_number, province_id, city_id, postal_code, detail_address, is_main_address, id }) {
      this.$data.titlePropsAddress = 'Update address'
      this.$refs.addRef.setIsShow(true, 'update', id)
      // setTimeout(() => {
      //   this.$refs.addRef.handleSetForm({
      //     receiver,
      //     phone_number,
      //     province_id: province_id.toString(),
      //     city_id: city_id.toString(),
      //     postal_code,
      //     detail_address,
      //     is_main_address
      //   }, id)
      // }, 50);
    },
    handleOpenAddAddress () {
      this.$data.titlePropsAddress = 'Add address'
      this.$refs.addRef.setIsShow(true)
    },
    handleOpenDeleteAddress ({ addressId }) {
      this.$data.addressId = addressId
      this.$refs.deleteRef.setIsShow(true)
    },
    async handleDeleteAddress () {
      try {
        const resp = await this.deleteAddress({ addressId: this.$data.addressId })
        if (resp.data === 'Address success deleted') {
          await this.fetchAddresses()
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleFetchAddresses () {
      try {
        await this.fetchAddresses()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm-address {
  .ecm-address__nav {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .ecm-address__search {
      width: 30%;
      margin-right: 20px;
      .ecm-address__form {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &::v-deep {
          .el-input {
            .el-input__inner {
              height: 35px;
              font-size: 14px;
              &:hover {
                border: 1px solid var(--color-blue-background);
              }
              &:focus {
                border: 1px solid var(--color-blue);
              }
              &:read-only {
                border: 1px solid #DCDFE6;
                cursor: default;
              }
            }
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
          }
        }
        .ecm-address__form-btn {
          &.btn--submit {
            border: none;
            outline: none;
            height: 35px;
            width: 35px;
            background: var(--color-blue-background);
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            margin-left: 5px;
            border-radius: 3px;
          }
        }
      }
    }
    .ecm-address__add-address {
      display: flex;
      justify-content: center;
      align-items: center;
      .ecm-address__add-address__btn {
        height: 35px;
        &.btn--add-address {
          border: none;
          outline: none;
          background: var(--color-blue-background);
          font-weight: 500;
          color: white;
          border-radius: 3px;
          padding: 1px 25px;
          cursor: pointer;
        }
      }
    }
  }
  .ecm-address__body {
    margin-top: 20px;
  }
}
</style>
